import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';

import type { CarouselItem, ListContext } from 'renderer/utils/analytics';
import { buildWishlistEvent } from 'renderer/utils/analytics';

const findItem = (items: CarouselItem[], lineNumber: string) => {
  const itemIndex = items.findIndex(item => item.searchProduct.lineNumber === lineNumber);
  if (itemIndex === -1) {
    return undefined;
  }

  return {
    index: itemIndex + 1,
    item: items[itemIndex],
  };
};

export const useFavouritesAnalytics = (items: CarouselItem[], listContext?: ListContext) => {
  const { trackEvent } = useAnalytics();

  const trackAdd = (lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildWishlistEvent('add_to_wishlist', found.item, found.index, listContext));
  };

  const trackRemove = (lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildWishlistEvent('remove_from_wishlist', found.item, found.index, listContext));
  };

  return { trackAdd, trackRemove };
};
